import { render } from "./andService.vue?vue&type=template&id=c21fa9fa"
import script from "./andService.vue?vue&type=script&lang=js"
export * from "./andService.vue?vue&type=script&lang=js"

import "./andService.vue?vue&type=style&index=0&id=c21fa9fa&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__